import type { NavigationGuardNext, RouteLocation } from 'vue-router';
import { RouteName } from '@/router/route-names';

const DienstverbandGuard = (
  to: RouteLocation,
  from: RouteLocation,
  next: NavigationGuardNext,
): void => {
  if (to.meta?.needsDienstverbandId && !to.query.dienstverbandId) {
    next({ name: RouteName.WerknemerIndex });
    return;
  }
  next();
};

export default DienstverbandGuard;
